export function getCurrentUrl(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
